import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as actions from '../../actions';
import Criterion from "./criterion";
import { formValueSelector, change } from 'redux-form/immutable'
import _ from 'lodash';
import {formatNumber} from "../../helpers/functions";
import {toJS} from "../hocs/toJs";
const selector = formValueSelector('criterion');

const parseCategories = (categories) => {
  const parsedCategories = [];
  categories.valueSeq().toArray().forEach( category => {
    parsedCategories.push({
      id: category.get('id'),
      name: category.get('name'),
      pillarId: category.get('pillarId'),
    })
  });
  return parsedCategories;
};

const parseDepartments = (departments) => {
  const parsedDepartments = [];
  departments.valueSeq().toArray().forEach( department => {
    parsedDepartments.push({
      id: department.get('id'),
      name: department.get('name'),
    })
  });
  return parsedDepartments;
};

const parseCriterion = (criterion) => {
  return {
    id: criterion.get('id'),
    name: criterion.get('name'),
    weightOld: criterion.get('weightOld'),
    weightNew: criterion.get('weightNew'),
    weightNewComing: criterion.get('weightNewComing'),
    createdDate: criterion.get('createdDate'),
    categoryId:  criterion.get('categoryId'),
    departmentId:  criterion.get('departmentId'),
    code:  criterion.get('code'),
  }
} ;

class CriterionHOC extends Component {

  componentDidMount(){
    this.props.getCategories({filter:{where: {or: [{deleted: false}, {deleted: null}]}}});
    this.props.getDepartments({filter: {where: {or: [{deleted: false}, {deleted: null}]}}});
    if(this.props.match.params.id){
      this.props.getCriterionById({id:this.props.match.params.id})
    }
  }

  componentWillReceiveProps(nextProps){

    //generate criterion code when department and category are specified in the form
    if(
      ( (this.props.criterionFormDepartment !== nextProps.criterionFormDepartment) ||
        (this.props.criterionFormCategory !== nextProps.criterionFormCategory)) &&
      (nextProps.criterionFormDepartment && nextProps.criterionFormCategory)
    ) {
      const selectedCategory = _.find(nextProps.categories, category => {
        return category.id === nextProps.criterionFormCategory
      });

      //generate code
      let code = `${formatNumber(nextProps.criterionFormDepartment, 3)}_${formatNumber(selectedCategory.pillarId, 2)}_${formatNumber(nextProps.criterionFormCategory, 3)}`;

      //if criterion is an existing one generate the criterion part of code
      if(this.props.match.params.id ){
        if(nextProps.criterionFormCode){
          code = `${code}_${nextProps.criterionFormCode.slice(-4)}`;
        } else {
          //generate code for existing criterion that has not code
          code += '_' + formatNumber(nextProps.criterion.id, 4);
        }
      }

      this.props.changeReduxForm(
        'criterion',
        'code',
        code)
    }

  }

  parseForm = (formIM) => {
    return {
      name: formIM.get('name'),
      weightOld: formIM.get('weightOld'),
      weightNew: formIM.get('weightNew'),
      weightNewComing: formIM.get('weightNewComing'),
      createdDate: new Date(),
      categoryId:  formIM.get('categoryId'),
      departmentId:  formIM.get('departmentId'),
      code:  formIM.get('code'),
    }
  };

  submitCriterion = (formIM) => {
    const form = this.parseForm(formIM);

    if(this.props.match.params.id){
      delete form.createdDate;
      this.props.updateCriterion({
        sendBody: form,
        id: this.props.match.params.id
      });
    } else {
      this.props.createCriterion({sendBody: form});
    }

  };

  render(){
    return (
      <Criterion
        {...this.props}
        submitCriterion={this.submitCriterion}
      />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    categories: state.categories.get('categories'),
    departments: state.departments.get('departments'),
    criterion: state.criterion.get('criterion'),
    loading: state.criterion.get('fetching') || state.criterion.get('posting') || state.criterion.get('updating'),
    message: state.criterion.get('message'),
    criterionFormDepartment: selector(state, 'departmentId'),
    criterionFormCategory: selector(state, 'categoryId'),
    criterionFormCode: selector(state, 'code')
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    createCriterion: (payload) => {
      dispatch(actions.createCriterion(payload))
    },
    getCategories: (payload) => {
      dispatch(actions.getCategories(payload))
    },
    getDepartments: (payload) => {
      dispatch(actions.getDepartments(payload))
    },
    getCriterionById: (payload) => {
      dispatch(actions.getCriterionById(payload))
    },
    updateCriterion: (payload) => {
      dispatch(actions.updateCriterion(payload))
    },
    changeCriterionState: (payload) => {
      dispatch(actions.changeCriterionState(payload))
    },
    changeReduxForm: (form, field, value) => {
      dispatch(change(form, field, value))
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(toJS(CriterionHOC));



// WEBPACK FOOTER //
// ./src/components/criterion/criterionHOC.js